document.addEventListener('DOMContentLoaded', function() {
    
    const form = document.querySelector('.c-savingsCal');
    const numberLabel = document.querySelector('.number-label');
    const annualResults = document.querySelector('.annual-results');
    const annualSavings = document.querySelector('.annual-savings-result');
    const breakEvenResults = document.querySelector('.break-even-results');

    // State and heating system costs (example based on the data provided)
    const heatingCosts = {
        'Alabama': {
                    'Electric': 0.14, 'Gas': 0.08, 'Water': 3, 'None': 0},
        'Alaska': {
                    'Electric': 0.23, 'Gas': 0.04, 'Water': 6, 'None': 0},
        'Arizona': {
                    'Electric': 0.13, 'Gas': 0.06, 'Water': 5, 'None': 0},
        'Arkansas': {
                    'Electric': 0.10, 'Gas': 0.05, 'Water': 2, 'None': 0},
        'California': {
                    'Electric': 0.33, 'Gas': 0.07, 'Water': 6, 'None': 0},
        'Colorado': {
                    'Electric': 0.14, 'Gas': 0.03, 'Water': 3, 'None': 0},
        'Connecticut': {
                    'Electric': 0.26, 'Gas': 0.06, 'Water': 6, 'None': 0},
        'Delaware': {
                    'Electric': 0.13, 'Gas': 0.06, 'Water': 4, 'None': 0},
        'Florida': {
                    'Electric': 0.14, 'Gas': 0.05, 'Water': 3, 'None': 0},
        'Georgia': {
                    'Electric': 0.13, 'Gas': 0.08, 'Water': 2, 'None': 0},
        'Hawaii': {
                    'Electric': 0.40, 'Gas': 0.16, 'Water': 5, 'None': 0},
        'Idaho': {
                    'Electric': 0.10, 'Gas': 0.02, 'Water': 3, 'None': 0},
        'Illinois': {
                    'Electric': 0.14, 'Gas': 0.05, 'Water': 2, 'None': 0},
        'Indiana': {
                    'Electric': 0.15, 'Gas': 0.05, 'Water': 3, 'None': 0},
        'Iowa': {
                    'Electric': 0.14, 'Gas': 0.03, 'Water': 3, 'None': 0},
        'Kansas': {
                    'Electric': 0.15, 'Gas': 0.03, 'Water': 2, 'None': 0},
        'Kentucky': {
                    'Electric': 0.12, 'Gas': 0.04, 'Water': 4, 'None': 0},
        'Louisiana': {
                    'Electric': 0.11, 'Gas': 0.05, 'Water': 2, 'None': 0},
        'Maine': {
                    'Electric': 0.22, 'Gas': 0.05, 'Water': 2, 'None': 0},
        'Maryland': {
                    'Electric': 0.14, 'Gas': 0.05, 'Water': 4, 'None': 0},
        'Massachusetts': {
                    'Electric': 0.31, 'Gas': 0.07, 'Water': 3, 'None': 0},
        'Michigan': {
                    'Electric': 0.17, 'Gas': 0.05, 'Water': 2, 'None': 0},
        'Minnesota': {
                    'Electric': 0.14, 'Gas': 0.05, 'Water': 2, 'None': 0},
        'Mississippi': {
                    'Electric': 0.12, 'Gas': 0.05, 'Water': 2, 'None': 0},
        'Missouri': {
                    'Electric': 0.13, 'Gas': 0.06, 'Water': 3, 'None': 0},
        'Montana': {
                    'Electric': 0.12, 'Gas': 0.03, 'Water': 3, 'None': 0},
        'Nebraska': {
                    'Electric': 0.11, 'Gas': 0.05, 'Water': 2, 'None': 0},
        'Nevada': {
                    'Electric': 0.13, 'Gas': 0.05, 'Water': 2, 'None': 0},
        'New Hampshire': {
                    'Electric': 0.26, 'Gas': 0.05, 'Water': 3, 'None': 0},
        'New Jersey': {
                    'Electric': 0.17, 'Gas': 0.05, 'Water': 5, 'None': 0},
        'New Mexico': {
                    'Electric': 0.13, 'Gas': 0.03, 'Water': 3, 'None': 0},
        'New York': {
                    'Electric': 0.21, 'Gas': 0.07, 'Water': 4, 'None': 0},
        'North Carolina': {
                    'Electric': 0.12, 'Gas': 0.07, 'Water': 2, 'None': 0},
        'North Dakota': {
                    'Electric': 0.11, 'Gas': 0.03, 'Water': 4, 'None': 0},
        'Ohio': {
                    'Electric': 0.14, 'Gas': 0.05, 'Water': 4, 'None': 0},
        'Oklahoma': {
                    'Electric': 0.11, 'Gas': 0.09, 'Water': 3, 'None': 0},
        'Oregon': {
                    'Electric': 0.12, 'Gas': 0.05, 'Water': 3, 'None': 0},
        'Pennsylvania': {
                    'Electric': 0.17, 'Gas': 0.05, 'Water': 3, 'None': 0},
        'Rhode Island': {
                    'Electric': 0.26, 'Gas': 0.05, 'Water': 3, 'None': 0},
        'South Carolina': {
                    'Electric': 0.13, 'Gas': 0.05, 'Water': 2, 'None': 0},
        'South Dakota': {
                    'Electric': 0.12, 'Gas': 0.03, 'Water': 3, 'None': 0},
        'Tennessee': {
                    'Electric': 0.12, 'Gas': 0.05, 'Water': 3, 'None': 0},
        'Texas': {
                    'Electric': 0.13, 'Gas': 0.05, 'Water': 3, 'None': 0},
        'Utah': {
                    'Electric': 0.11, 'Gas': 0.03, 'Water': 4, 'None': 0},
        'Vermont': {
                    'Electric': 0.19, 'Gas': 0.06, 'Water': 2, 'None': 0},
        'Virginia': {
                    'Electric': 0.12, 'Gas': 0.05, 'Water': 3, 'None': 0},
        'Washington': {
                    'Electric': 0.10, 'Gas': 0.05, 'Water': 3, 'None': 0},
        'West Virginia': {
                    'Electric': 0.12, 'Gas': 0.05, 'Water': 8, 'None': 0},
        'Wisconsin': {
                    'Electric': 0.15, 'Gas': 0.03, 'Water': 2, 'None': 0},
        'Wyoming': {
                    'Electric': 0.11, 'Gas': 0.05, 'Water': 4, 'None': 0}
        };

    form.addEventListener('submit', function(event) {
        event.preventDefault(); // Prevent the form from submitting traditionally
        console.log("<-------------------------------->");
        numberLabel.style.display = "none";

        // Retrieve user inputs
        const poolLength = parseFloat(document.querySelector('input[name="poolLength"]').value);
        const poolWidth = parseFloat(document.querySelector('input[name="poolWidth"]').value);
        const selectedState = document.querySelector('.select_flds[name="state"]').value;
        const selectedHeatingSystem = 'None'
        
        console.log("Inputs:", poolLength, poolWidth, selectedState, selectedHeatingSystem);

        // Get the cost factor based on state and heating system
        const heatingSystemValue = heatingCosts[selectedState][selectedHeatingSystem];
        
        // Get the cost factor based on state and heating system
        const electricValue = heatingCosts[selectedState]['Electric'];
        const gasValue = heatingCosts[selectedState]['Gas'];
        const waterValue = heatingCosts[selectedState]['Water'];

        console.log("Heating System Value:", heatingSystemValue);
        console.log("\nelectricValue:", electricValue, "\ngasValue: ", gasValue, "\nwaterValue: ", waterValue);

        // Calculate the area of the pool
        const area = poolLength * poolWidth;

        // Calculate water usage
        const waterUsage = Math.round(840/32/8*24.54 * 1 * area);
        
        // Calculate water Savings
        const waterSavings = waterUsage/1000 * waterValue;

        // Calculate Emisions savings
        const emissionsSavings = Math.round(1243/32/8*0.2058 * 1 * area);

        // Energy Savings
        const energySavings = 1985 * 1 * heatingSystemValue;
        
        const chemicalCost = 0.684 * area;
        // const chemicalCost = 200;

        const chemicalSavings = chemicalCost * 0.4;

        // RRP Value
        const RRP = 1.44;

        // Cover RRP cost
        const coverCostRRP = area * RRP;

        // All Conts
        console.log("Area: ", area, "\nwaterUsage: ", waterUsage, "\nwaterSavings: ", waterSavings, "\nemissionsSavings: ", emissionsSavings, "\nenergySavings: ", energySavings, "\nchemicalCost: ", chemicalCost, "\nchemicalSavings: ", chemicalSavings, "\nRRP: ", RRP, "\ncoverCostRRP: ", coverCostRRP);

        // Calculate annual savings
        const annualSavings1 = waterSavings + energySavings + chemicalSavings - coverCostRRP;
        console.log("orgAnnualSavings1: waterSavings + energySavings + chemicalSavings - coverCostRRP: ", annualSavings1);
        // annualResults.textContent = annualSavings1.toFixed(2); // Update the display

        // Calculate the break-even point
        const breakEven1 = coverCostRRP / annualSavings1;
        console.log("orgBreak Even: coverCostRRP / annualSavings1: ", breakEven1);
        // breakEvenResults.textContent = breakEven1.toFixed(1); // Update the display

        const thesavings = waterSavings + energySavings + chemicalSavings; // Recurring annual savings
        console.log("Recurring Annual Savings: ", thesavings);

        // First year savings might be different if we consider the initial cost
        const firstYearSavings = thesavings - coverCostRRP;
        // annualResults.textContent = firstYearSavings.toFixed(2);
        console.log("1st Year Savings: ", firstYearSavings);
        
        firstYearSavingsamount = firstYearSavings.toFixed(2);
        animateNumber("annual-results-id", 0, firstYearSavingsamount, 1000);

        semicirclebar();
        
        // Calculate break-even year
        let cumulativeSavings = 0;
        let breakEvenYear = 0;

        while (cumulativeSavings < coverCostRRP) {
            cumulativeSavings += thesavings;  // Add yearly savings
            breakEvenYear++;                // Increment year
        }

        // Display results Break Even Year
        // breakEvenResults.textContent = breakEvenYear;
        console.log("breakEven Loop: ", breakEvenYear);
        
        // Once break-even is reached, all subsequent years should have the same savings as `thesavings`
        // annualSavings.textContent = thesavings.toFixed(2);
        thesavingsamount = thesavings.toFixed(2);
        animateNumber("annual-savings-id", 0, thesavings, 1500); // Animates from 0 to 100 in 2 seconds

        //
        // Calculate exact break-even point in years and months
        //
        const yearsComplete = breakEvenYear - 1; // Full years before the final year reaching break-even
        const savingsLastYear = cumulativeSavings - thesavings; // Savings just before the last increment
        const remainingSavingsNeeded = coverCostRRP - savingsLastYear; // Remaining savings needed after last full year
        const months = Math.ceil((remainingSavingsNeeded / thesavings) * 12); // Calculate months needed in the last year

        // Display results
        // annualResults.textContent = "Annual Savings: $" + thesavings.toFixed(2);
        // breakEvenResults.textContent = "Break-even in full years: " + yearsComplete + " year(s)";
        breakEvenResults.textContent = formatBreakEven(yearsComplete, months);

        function semicirclebar() {
            const progress = document.getElementById('progressArc');
            progress.classList.remove('animate'); // Reset if needed
            void progress.offsetWidth; // Reflow hack to restart animation
            progress.classList.add('animate');
            progress.style.opacity = "1";
        }

        // Function to format break-even year and month
        function formatBreakEven(fullYears, months) {
            let monthText = months > 0 ? `${months}mo` : "";
            if(fullYears <= 0){
                return `${monthText}`;
            }else{
                return `${fullYears}Yrs ${monthText}`;
            }
        }

        function animateNumber(elementId, start, end, duration) {
            const element = document.getElementById(elementId);
            const frameRate = 60; // frames per second
            const totalFrames = Math.round((duration / 1000) * frameRate);
            let frame = 0;

            const update = () => {
                frame++;
                const progress = frame / totalFrames;
                const current = start + (end - start) * easeOutQuad(progress);
                element.textContent = current.toFixed(2);

                if (frame < totalFrames) {
                    requestAnimationFrame(update);
                } else {
                    element.textContent = end.toFixed(2); // Ensure final value is exact
                }
            };

            function easeOutQuad(t) {
                return t * (2 - t);
            }

            requestAnimationFrame(update);
        }

    });
});

$(document).ready(function(e) {
    
    // $('ul.menu-list li a').click(function(event) {
    //     event.preventDefault();
    //     var ids = $(this).attr('href');
    //     $('html, body').animate({
    //         scrollTop: $(ids).offset().top - 50
    //     }, 2000);
    // });
    $('ul.menu-list li a').click(function(event) {
        if (!$(this).hasClass('j-home')) {
            event.preventDefault();
            var ids = $(this).attr('href');
            $('html, body').animate({
                scrollTop: $(ids).offset().top - 50
            }, 2000);
        }
    });
    
    $(".btn_scorall").click(function() {
        $('html, body').animate({
            scrollTop: $("#order").offset().top - 50
        }, 2000);
    });
    

    
    $('.s5__box__before-after').imagesLoaded( function() {
        $(".s5__box__before-after").twentytwenty({
            default_offset_pct: 0.5
        });
    });
    
    $('.sizeSelector').change(function(e) {
        var sizesel = $(this).val();
        $(this).closest('.frmElemts').find('#packsize').html('$' + sizesel);
    });
    
    
    $('.banner_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        asNavFor: '.banner_slider_nav',
        autoplay: false,
        autoplaySpeed: 11000,
        dots: false,
        responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow:1,
                slidesToScroll: 1,
                dots: false,
                centerMode: false,
                variableWidth: false,
                arrows: true,
            }
        }
        ]
    });

    $('.banner_slider_nav').slick({
        slidesToShow:5,
        slidesToScroll: 1,
        asNavFor: '.banner_slider',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        infinite: true,
        arrows: false,
        rtl: false,
    });
    
    $('.s7_review_block').slick({
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,				
        autoplaySpeed:8000,
        arrows: true,
        responsive: [
            
            {
                breakpoint: 9999,
                settings: "unslick"
            
            },
            
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    }); 
    
    
    
    var numSlick = 0;
        $('.addOn_slider').each( function() {
        numSlick++;
        $(this).addClass( 'slider-' + numSlick ).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            asNavFor: '.addOn_slider_nav.slider-' + numSlick
        });
        });
        
        numSlick = 0;
        $('.addOn_slider_nav').each( function() {
        numSlick++;
        $(this).addClass( 'slider-' + numSlick ).slick({
            vertical: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.addOn_slider.slider-' + numSlick,
            arrow: false,
            focusOnSelect: true,
        });
        });
    


    //Accordion JS 
    $(".accordion").click(function() {
        
        var questionDiv = $(this);
        var answerDiv   = $(this).next('.acdn-content');
        var idx = $('.acdn-content').index(answerDiv);
        
        $('.acdn-content').each(function(index, ansDiv) {
            if(index != idx && $(ansDiv).is(':visible')) {
                $(ansDiv).slideUp(500, function() {
                    $(ansDiv).prev('.accordion').removeClass('accordion-open');
                });
            }
        });
                    
        if (answerDiv.is(':visible')) {
            answerDiv.stop().slideUp(500, function() {
                questionDiv.removeClass('accordion-open');
            });
        } else {
        questionDiv.addClass('accordion-open');
        answerDiv.stop().slideDown(500);
        }
    });
    
    //$('.menu-list').scroller();
    
    // calculator(334,15);
    
});

    function calculator(defWeight,percentage) {
        const range = document.querySelector('.circle-range');
        const slider = range.querySelector('.slider-range');
        const img = range.querySelector('img');
        const result = range.querySelector('.range-result');
        const weight = document.querySelector('.revolutionary .weight .number');
        const maxOutputDegrees = 505;

        if(!defWeight){
            const defWeight = 205;
        }
        if(!percentage){
            const percentage = 20;
        }

        let isDragging = false;

        img.ondragstart = function() {
            return false;
        };

        // range.addEventListener('mousedown', () => {isDragging = true});
        // range.addEventListener('mouseup', () => {
        //     isDragging = false;
        // });
        
        function onMouseUp() {
                btnSubmit.classList.remove('disabled');
                document.removeEventListener('touchend', onMouseUp);
                document.removeEventListener('touchmove', onMouseMove);
            }

        document.addEventListener('mousemove', e => {
            e.preventDefault();
            e.stopPropagation();

            if (e.target.closest('.circle-range') != null) {
                if(isDragging) {
                    onMouseMove(e);
                }
            } else {
                isDragging = false;
            }
        });

        // range.addEventListener('click', (e) => {
        //     onMouseMove(e);
        // });

        function onMouseMove(e) {
            let rect = range.getBoundingClientRect();
            let centerX = rect.left + rect.width / 2;
            let centerY = rect.top + rect.height;

            let clickX = (e.clientX != undefined) ? e.clientX : e.touches[0].clientX;
            let clickY = (e.clientY != undefined) ? e.clientY : e.touches[0].clientY;
            
            let radians = Math.atan2(clickY - centerY, clickX - centerX); 
            let degrees = radians * (180 / Math.PI);
            
            degrees = 180 + degrees;

            if (degrees == 0 || degrees > 180) {
                return;
            }

            let scaledDegrees = degrees * (maxOutputDegrees / 180);
            let percent = Math.round((Math.round(degrees) / 180) * 100);
            let min = 0;
            let max = 505;
            let convertedValue = ((percent - 0) * (max - min) / (100 - 0)) + min;
            slider.style.transform = `rotate(${degrees}deg)`;
            result.textContent = Math.round(convertedValue);
            weight.textContent = Math.round(convertedValue / 100 * percentage);
        }

        function defaultCalc() {
            result.innerHTML = defWeight;
            slider.style.transform = `rotate(62deg)`;
            
            result.textContent = Math.round(defWeight);
            weight.textContent = Math.round(defWeight * (percentage/100).toFixed(2));
        }

        defaultCalc();
    }

$(document).scroll(function() {
        
    if ($(this).scrollTop() > 40){
        $('.top-fix-bar').addClass('fixed-nav');
    }else{
        $('.top-fix-bar').removeClass('fixed-nav');
    }
    
    if ($(this).scrollTop() > 10){
    $('.mobilemenu').addClass('mobimenu-top');
    }else{
    $('.mobilemenu').removeClass('mobimenu-top');
    }
    
});